import React, {useState} from 'react'
import { useAtom, useCtx } from "@reatom/npm-react";
import { modelStore, participantsAtom } from "../model";
import './style.css'
import Loader from '../../Utils/Loader';


function TestingBox({}){
    const ctx = useCtx()

    const values = []

    const [is_active, setActive] = useState(true)

    function toggle(){
        setActive( !is_active )
    }

    const [participants, ] = useAtom(participantsAtom)
    

    for(const [key, model] of Object.entries(modelStore)){
        const [value, setValue] = useAtom(model.atom)
        values.push({
            key: key,
            value: value
        })
    }

    // const participants = ctx.get(participantsAtom)
    // console.log(JSON.stringify(participants))
    
    return (
        <div class="testing-box">
            <div class="testing-box__toggle" onClick={toggle}>
                testing box
            </div>
            {is_active && (
                <div class="testing-box__body">
                    <div class="testing-box__loaders">
                            <Loader 
                                type="1"
                                active={true}
                                />
                            <Loader 
                                type="2"
                                active={true}
                                />
                            <Loader
                                type="3"
                                active={true}
                                />
                            <Loader
                                type="4"
                                active={true}
                                />
                    </div>
                    <div class="testing-box__list">
                        {values.map((value) => (
                            <div>
                                {!value.key.includes(':') && (
                                    <div key={value.key}>
                                        {value.key}: {
                                            value.value===true 
                                            ? 'true': 
                                                (value.value === false ? 'false' : String(value.value))
                                        }
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    
                        {/* {JSON.stringify(participants_sorted, null, 2)} */}
                        {/* {participants_sorted.map((item) => ( */}
                        {participants.map((item, i) => (
                            <pre key={i}>
                                {`item.id: ${item.id}========\n`
                                + `item.seed: ${item.seed}\n`
                                + `item.player: ${item.player?.id} ${item.player?.first_name} ${item.player?.name}\n`
                                + `item.player_1: ${item.player_1?.id} ${item.player_1?.first_name} ${item.player_1?.name}\n`
                                + `item.player_2: ${item.player_2?.id} ${item.player_2?.first_name} ${item.player_2?.name}\n`
                                + `item.player_3: ${item.player_3?.id} ${item.player_3?.first_name} ${item.player_3?.name}\n`
                                }
                            </pre>
                        ))}
                </div>
            )}
        </div>
    )
}

export default TestingBox